import * as types from '../constants';

export const setBookingList = bookingList => ({
  type: types.SET_BOOKING_LIST,
  payload: bookingList
});
